
import { useState } from 'react';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav className="bg-white shadow-sm">
      <div className="container mx-auto px-8 lg:px-12 max-w-[1140px]">
        <div className="flex items-center justify-between h-24">
          {/* Logo */}
          <div className="flex items-center">
            <a href="/" className="cursor-pointer">
              <img
                src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/cad045eb4b76963ad35a569d344f5dbe.png"
                alt="Raissy"
                className="h-20 cursor-pointer"
              />
            </a>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <a
              href="/"
              className="text-base font-bold text-[#1a1a1a] hover:text-[#0891b2] transition-colors cursor-pointer"
            >
              Home
            </a>
            <a
              href="/about"
              className="text-base font-bold text-[#1a1a1a] hover:text-[#0891b2] transition-colors cursor-pointer"
            >
              About
            </a>
            <a
              href="/services"
              className="text-base font-bold text-[#1a1a1a] hover:text-[#0891b2] transition-colors cursor-pointer"
            >
              Services
            </a>
            <a
              href="/projects"
              className="text-base font-bold text-[#1a1a1a] hover:text-[#0891b2] transition-colors cursor-pointer"
            >
              Projects
            </a>
            <a
              href="/news"
              className="text-base font-bold text-[#1a1a1a] hover:text-[#0891b2] transition-colors cursor-pointer"
            >
              News
            </a>
            <a
              href="/contact"
              className="text-base font-bold text-[#1a1a1a] hover:text-[#0891b2] transition-colors cursor-pointer"
            >
              Contact
            </a>
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:flex items-center">
            <a
              href="/contact"
              className="bg-[#0891b2] text-white px-6 py-3 rounded-md text-base font-medium hover:bg-[#0e7490] transition-all whitespace-nowrap cursor-pointer"
            >
              Get Quote
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden cursor-pointer"
          >
            <i
              className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-[#1a1a1a]`}
            ></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden absolute top-full left-0 right-0 bg-white shadow-lg border-t border-gray-200 z-50">
          <nav className="flex flex-col p-6 space-y-4">
            <a
              href="/"
              className="text-base font-bold text-[#1a1a1a] hover:text-[#0891b2] transition-colors cursor-pointer"
              onClick={() => setMobileMenuOpen(false)}
            >
              Home
            </a>
            <a
              href="/about"
              className="text-base font-bold text-[#1a1a1a] hover:text-[#0891b2] transition-colors cursor-pointer"
              onClick={() => setMobileMenuOpen(false)}
            >
              About
            </a>
            <a
              href="/services"
              className="text-base font-bold text-[#1a1a1a] hover:text-[#0891b2] transition-colors cursor-pointer"
              onClick={() => setMobileMenuOpen(false)}
            >
              Services
            </a>
            <a
              href="/projects"
              className="text-base font-bold text-[#1a1a1a] hover:text-[#0891b2] transition-colors cursor-pointer"
              onClick={() => setMobileMenuOpen(false)}
            >
              Projects
            </a>
            <a
              href="/news"
              className="text-base font-bold text-[#1a1a1a] hover:text-[#0891b2] transition-colors cursor-pointer"
              onClick={() => setMobileMenuOpen(false)}
            >
              News
            </a>
            <a
              href="/contact"
              className="text-base font-bold text-[#1a1a1a] hover:text-[#0891b2] transition-colors cursor-pointer"
              onClick={() => setMobileMenuOpen(false)}
            >
              Contact
            </a>
          </nav>
        </div>
      )}
    </nav>
  );
};

export default Header;
